import { createSlice } from '@reduxjs/toolkit';
import i18n from '../../i18n/i18n';
import { APP_STATUS } from '../../constants';
import { IPaymentState } from '../../interface';
import { getInvoices } from '../action';

const initialState: IPaymentState = {
  isLoading: false,
  status: APP_STATUS.IDLE,
  message: '',
  invoices: [],
};

const paymentSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInvoices.pending, (state) => {
        state.isLoading = true;
        state.status = APP_STATUS.INITIAL;
      })
      .addCase(getInvoices.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = APP_STATUS.SUCCESS;
        state.invoices = action.payload;
      })
      .addCase(getInvoices.rejected, (state, action) => {
        state.isLoading = false;
        state.status = APP_STATUS.ERROR;
        state.message = action.payload?.message || i18n.t('toast.failed_to_fetch_invoices', 'Failed to fetch invoices');
      });
  },
});

export const { resetState } = paymentSlice.actions;

export default paymentSlice.reducer;
